import {combineReducers} from 'redux'
import readyForDelivery from './readyForDelivery'
import deliveryNotes from './deliveryNotes'
import deliveries from './deliveries'
import quoteSelector from './quoteSelector'

export default combineReducers({
  readyForDelivery,
  deliveryNotes,
  deliveries,
  quoteSelector,
})
